<template>
  <div>
    <b-breadcrumb :items="breadcrumbs"/>
    <h2>Manage case</h2>
    <loading :loading="isLoading">
      <error :error="error"/>
      <div v-if="page && page.IsMisnomer.length > 0">
        <b-card header="Existing misnomer">
          <div style="font-weight: bold">{{ page.IsMisnomer[0].reason }}</div>
          <div v-if="page.IsMisnomer[0].notes">&ldquo;{{ page.IsMisnomer[0].notes }}&rdquo;</div>
          <small>by {{ page.IsMisnomer[0].author }} on {{ page.IsMisnomer[0].created_at | moment('Do MMM YYY HH:mm') }}</small>
          <div style="margin-top:20px">
            <b-link @click="unflag" class="text-danger card-link">Unflag misnomer</b-link>
          </div>
        </b-card>
      </div>
      <div v-if="page && page.IsMisnomer.length === 0">
        <!-- create new exclusion -->
        <b-form-group
          id="misnomerReason"
          description="Cause of this correlation being anapparent misnomer"
          label="Reason"
          label-for="reason"><b-form-select v-model="reason" :options="reasons" />
        </b-form-group>
        <b-form-group
          id="misnomerNotes"
          description="Any additional information that may be relevant"
          label="Notes"
          label-for="notes">
          <b-form-textarea id="notes"
                v-model="notes"
                placeholder="Your notes here"
                :rows="6"/>
        </b-form-group>
        <b-button-group>
          <b-button variant="primary" @click="flagNow">Flag</b-button>
          <b-button variant="danger" @click="goBack">Cancel</b-button>
        </b-button-group>
      </div>
    </loading>
  </div>  
</template>

<script>
import Loading from '@/components/Loading.vue'
import Error from '@/components/Error.vue'

export default {
  components: { Loading, Error },
  data () {
    return {
      breadcrumbs: [
        {text: 'All Notifications', to: `/alerts/${this.$route.params.alert_category}`}, 
        {text: 'Notification', to: `/alerts/${this.$route.params.alert_category}/${this.$route.params.reference}`},
        {text: 'Misnomer', active: true },
      ],
      isLoading: false,
      error: null,
      page: null,
      category: this.$route.params.alert_category,
      reference: this.$route.params.reference,
      reason: 'Data Quality Issue',
      notes: null,
      reasons: [
        'Data Quality Issue',
        'Timing',
        'Mitigating Reason',
        'Cannot Afford to Pay',
        'False Positive'
      ]
    };
  },
  mounted () {
    this.loadState();
  },
  methods: {
    goBack () {
      this.$router.back(1);
    },

    loadState () { 
      this.isLoading = true;
      const { access_token } = this.$store.state.oidcStore;
      this.$reportingApi.renderPage('panessex', access_token, {
        pageName: 'ViewNotificationMisnomer',
        parameters: {
          category: this.category,
          reference: this.reference,
        },
      })
      .then(page => { this.page = page; this.isLoading = false; })
      .catch(e => { this.error = e.message; this.isLoading = false; });
    },

    unflag () {
      this.isLoading = true;
      const { access_token } = this.$store.state.oidcStore;
      this.$reportingApi.runAction('panessex', access_token, {
        actionName: 'UnflagMisnomer',
        parameters: {
          category: this.category,
          reference: this.reference,
        },
      })
      .then(() => { this.loadState(); this.isLoading = false; })
      .catch(e => { this.error = e.message; this.isLoading = false; });
    },

    flagNow () {
      this.isLoading = true;
      const { access_token } = this.$store.state.oidcStore
      this.$reportingApi.runAction('panessex', access_token, {
        actionName: 'FlagAsMisnomer',
        parameters: {
          category: this.category,
          reference: this.reference,
          reason: this.reason,
          notes: this.notes
        }
      })
      .then(() => {
          this.reason = 'Data Quality Issue'
          this.notes = null
          this.loadState()
          this.isLoading = false
      })
      .catch(e => { this.error = e.message; this.isLoading = false })
    }
  }
}
</script>
